import { Button } from "@kobalte/core";
import { styled } from "solid-styled-components";

export const VoiceSwitcherWrapper = styled(Button.Root)<{ active: boolean }>`
  width: 100%;
  height: 70px;
  border-radius: 10px;
  ${({ theme, active }) =>
		active
			? `
    background: ${theme?.button?.background};
    *{
      color: ${theme?.button?.color};
    }
   `
			: `
    background: ${theme?.input?.background};
   `};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 0 10px;
`;
